module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div class=\"row\">\r\n	<div class=\"col-md-12\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"none\" checked=\"checked\" />\r\n		New Instance\r\n	</div>\r\n	<div class=\"col-md-12\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"existing2\" />\r\n		Existing Instance\r\n	</div>\r\n	<div class=\"col-md-12\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"new\" />\r\n		New Child Instance\r\n	</div>\r\n	<div class=\"col-md-12\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"single\" />\r\n		Single Child Instance\r\n	</div>\r\n	<div class=\"col-md-12\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"existing\" />\r\n		Existing Child Instance\r\n	</div>\r\n	<div class=\"col-md-12\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"parent\" />\r\n		Parent Instance\r\n	</div>\r\n</div>\r\n<div class=\"row\">\r\n	<div class=\"col-md-12\">\r\n		<input type=\"checkbox\" name=\"newWindow\" >\r\n		Open in a new window\r\n	</div>\r\n	<div class=\"col-md-12\">\r\n		<input type=\"checkbox\" name=\"showError\" >\r\n		Show error messages\r\n	</div>\r\n</div>\r\n\r\n\r\n")
  }
  return __output;

}